import { render, staticRenderFns } from "./underspecifiedPenaltyCurve.vue?vue&type=template&id=64e6f708"
import script from "./underspecifiedPenaltyCurve.vue?vue&type=script&lang=js"
export * from "./underspecifiedPenaltyCurve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports